<template>
  <div class="basedata">

    <template v-if="!aenderung">

      <h1 class="ueberplus primary--text">Angebot Rechtsschutz für Privatkunden</h1>

      <!-- PKS: Select makler and tarif --------------------------------------------->
      <select-tarif v-if="selectTarifAllowed"
                    :state-path="statePath" />

      <!-- Versicherungsnehmer ------------------------------------------------------>

      <div class="semanticsection-title2 primary--text">Versicherungsnehmer</div>

      <div class="section">
        <v-row :class="$vuetify.breakpoint.mdAndUp ? 'space-between' : ''"
                  no-gutters
                  align-start
                  justify-start>

          <v-col cols="12" md="11">
            <v-radio-group v-model="anrede"
                           row 
                           hide-details>
                <v-radio value="F"
                         color="primary"
                         label="Frau" />

                <v-radio value="H"
                         color="primary"
                         label="Herr" />

                <v-radio value="kA"
                         color="primary"
                         label="keine Angabe" />
            </v-radio-group>
          </v-col><v-col cols="0" md="1"/>

          <v-col cols="12"
                 md="6">
            <v-text-field v-model="titel"
                          color="primary"
                          label="Titel" />
          </v-col><v-col cols="0" md="6"/>

          <v-col cols="12"
                 md="6">
            <v-text-field v-model.trim="firstName"
                          v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                          :error-messages="errors.collect('firstName')"
                          data-vv-as="Vorname"
                          name="firstName"
                          label="Vorname"
                          class="required" />
          </v-col>

          <v-col cols="12"
                 md="6">
            <v-text-field v-model.trim="lastName"
                          v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                          :error-messages="errors.collect('lastName')"
                          data-vv-as="Nachname"
                          name="lastName"
                          label="Nachname"
                          class="required" />
          </v-col>

        </v-row>
      </div>

    </template>

    <!-- Familienstand ------------------------------------------------------>

    <div class="primary--text semanticsection-title2">Familienstand</div>

    <div class="section">

      <v-radio-group v-model="family"
                     v-validate="{ required: aenderung }"
                     :hide-details="!aenderung"
                     :error-messages="errors.collect('Familie')"
                     name="Familie"
                     class="pt-0 fill-parent"
                     @change="checkSUS">
        <v-row no-gutters>
          <v-col cols="12"
                 sm="3">
            <v-radio value="MPH"
                     color="primary">
              <template v-slot:label>
                <span class="mr-1">Familie</span>
                <site-tooltip titel="Familie">
                  Mehrpersonen-Haushalt, Ehe- oder Lebensgemeinschaft/-partnerschaft
                </site-tooltip>
              </template>
            </v-radio>
          </v-col>
          <v-col :class="$vuetify.breakpoint.xsOnly ? 'pt-4' : '' "
                 cols="12"
                 sm="9">
            <v-radio label="Single/Alleinerziehend mit Kind"
                     value="EPH"
                     color="primary" />
          </v-col>
        </v-row>
      </v-radio-group>

    </div>

    <!-- öfftl Dienst ------------------------------------------------------>

    <div class="primary--text semanticsection-title2">Angestellte(r) im öffentlichen Dienst</div>

    <div class="section">

      <v-checkbox v-model="civilServant"
                  label="tätig im öffentlichen Dienst"
                  class="pt-0"
                  hide-details
                  color="primary"
                  @change="checkSUS"/>

    </div>

    <!-- Laufzeit ------------------------------------------------------>

    <div class="primary--text semanticsection-title2">Laufzeit</div>
    <div class="section">

      <v-radio-group v-model="contractlength"
                     v-validate="{ required: aenderung }"
                     :hide-details="!aenderung"
                     :error-messages="errors.collect('Laufzeit')"
                     name="Laufzeit"
                     class="pt-0 fill-parent"
                     @change="checkSUS">
        <v-row no-gutters>
          <v-col cols="12"
                 sm="3">

            <v-radio
              value="1"
              label="ein Jahr"
              color="primary" />

          </v-col>
          <v-col :class="$vuetify.breakpoint.xsOnly ? 'pt-4' : '' "
                 cols="12"
                 sm="9">

            <v-radio v-if="threeYearsAllowed"
                     value="3"
                     label="drei Jahre (5 % Laufzeit-Rabatt)"
                     color="primary" />

          </v-col>
        </v-row>
      </v-radio-group>

    </div>

    <!-- Versicherungsschutz ------------------------------------------------------>

    <div class="primary--text semanticsection-title2">Versicherungsschutz &nbsp;
      <span v-if="errors.has('category')"
            class="error--text errormessage">{{ errors.first("category") }}</span>
      <div class="dmb-form-text">{{ tarifCombinationsText }}</div>
    </div>

    <div class="section">
      <v-row no-gutters>
        <v-col cols="12"
               sm="4">
          <v-checkbox v-model="categories"
                      v-validate="'required|categoriesAllowed:' + activeTarif"
                      class="pt-0"
                      label="Privat"
                      value="P"
                      name="category"
                      color="primary"
                      hide-details
                      @change="categoryChange" />
        </v-col>
        <v-col cols="12"
               sm="4">
          <v-checkbox v-model="categories"
                      :disabled="categories.indexOf('P') < 0"
                      class="pt-0"
                      label="Beruf"
                      value="B"
                      name="category"
                      color="primary"
                      hide-details
                      @change="categoryChange" />
        </v-col>
        <v-col cols="12"
               sm="4">
          <v-checkbox v-if="showWohnen"
                      v-model="categories"
                      :disabled="categories.indexOf('P') < 0"
                      class="pt-0"
                      label="Wohnen"
                      value="W"
                      name="category"
                      color="primary"
                      hide-details
                      @change="categoryChange" />
        </v-col>
      </v-row>
      <v-checkbox v-model="categories"
                  class="pt-0"
                  label="Verkehr"
                  value="V"
                  name="category"
                  color="primary"
                  hide-details
                  @change="categoryChange" />
      <v-checkbox v-if="showMieterVorGericht"
                  v-model="categories"
                  class="pt-0"
                  label="Mietrechtsschutz vor Gericht"
                  value="M"
                  name="category"
                  color="primary"
                  hide-details
                  @change="categoryChange" />

    </div>

           <v-checkbox
                  v-if="showYoligOnly"
                  v-model="nurnachhaltig"
                  class="pt-12 no-max-width"
                  value="Y"
                  name="category"
                  color="primary"
                  hide-details
                  @change="categoryChange">
                  <span slot="label">
                  nur Rechtssschutz YOLIG anzeigen 
                  <site-tooltip>
                    YOLIG ist Rechtsschutz für Menschen, die sich aktiv für ein zukunftsbewusstes 
                    Leben entscheiden: Für Menschen, die auf Produkte Wert legen, bei denen pro Vertrag
                    eine Spende fürs Klima erfolgt und der Beitrag für E-Autos günstiger ist.
                  </site-tooltip>
                  </span>
           </v-checkbox>
           
    <!-- Umfang ------------------------------------------------------>

    <template v-if="showTraffic">

      <div class="primary--text semanticsection-title2">Umfang
      </div>

      <div class="section">

        <v-radio-group v-model="trafficType"
                       v-validate="{ required: aenderung }"
                       :hide-details="!aenderung"
                       :error-messages="errors.collect('Umfang')"
                       name="Umfang"
                       class="pt-0 mb-0">

          <v-radio v-if="familieVerkehrsRsAllowed"
                   value="Familie"
                   color="primary"
                   label="alle auf die Familie (den versicherten Personenkreis) zugelassenen Kfz" />

          <v-radio value="Versicherungsnehmer"
                   color="primary"
                   class="pt-4">
            <span slot="label">
              alle auf den Versicherungsnehmer zugelassenen Kfz
              <site-tooltip>
                Versicherungsschutz für alle auf den Versicherungsnehmer zugelassenen Fahrzeuge, alle berechtigten Fahrer und Insassen und neben dem VN der eheliche/eingetragene Lebenspartner bei der Teilnahme am öffentlichen Straßenverkehr. Sollen neben dem Versicherungsnehmer weitere Personen beim Fahren fremder Fahrzeuge oder neben dem VN und dem ehelichen/eingetragenen Lebenspartner als Teilnehmer am öffentlichen Straßenverkehr versichert sein, wählen Sie bitte „alle auf die Familie (versicherten Personenkreis) zugelassenen Kfz“.

              </site-tooltip>
            </span>
          </v-radio>

          <v-radio v-if="fahrerRsAllowed"
                   value="Fahrer"
                   color="primary"
                   class="pt-4">
            <span slot="label">
              Fahrer-Rechtsschutz
              <site-tooltip>
                Versicherungsschutz besteht <strong>ausschließlich</strong> für die im Versicherungsschein genannte Person bei der Teilnahme am öffentlichen Verkehr in ihrer Eigenschaft als Fahrer jedes Motorfahrzeuges zu Lande, zu Wasser oder in der Luft sowie Anhängers (Fahrzeug), das weder ihr gehört noch auf sie zugelassen ist.
              </site-tooltip>
            </span>
          </v-radio>

          <v-radio v-if="fahrzeugRsAllowed"
                   value="Fahrzeug"
                   class="pt-4"
                   color="primary">
            <span slot="label">
              Fahrzeug-Rechtsschutz
              <site-tooltip>
                Versicherungsschutz für alle berechtigten Fahrer und Insassen der mit Kennzeichen genannten Fahrzeuge.<br>
                Möchten Sie mehr als 5 Fahrzeuge versichern, rufen Sie bitte unsere Makler-Hotline an
                <a :href="'tel:' + maklerService.phoneClickable"
                   class="secondary--text">{{ maklerService.phone }}
                </a>.
              </site-tooltip>
            </span>
          </v-radio>

        </v-radio-group>

        <v-row no-gutters class="flex-nowrap">

          <v-col cols="0"
                 md="4" />
          <v-col id="kfz-details"
                 cols="12"
                 md="8">
            <v-row v-if="trafficType ==='Fahrzeug'"
                      no-gutters>

              <template v-for="(kfz, index) in kfzs">

                <v-col v-if="index <= showkfz"
                       :key="index"
                       cols="12"
                       class="kfz bg-dimmed round-corners">
                  <v-icon v-if="index!==0 && index===showkfz"
                          class="delete-kfz"
                          @click="deleteKfz(index)">close
                  </v-icon>
                  <v-row no-gutters>
                    <v-col cols="3">
                      <div class="kfz-label">KFZ {{ index + 1 }}</div>
                    </v-col>
                    <v-col cols="9">
                      <v-text-field v-model.trim="kfzs[index]"
                                    v-validate="{ required: true, regex: /(?=.{3,11}$)(^[A-ZÄÖÜ]{1,3}[ -]?[A-Z]{1,2} ?[1-9]\d{0,3} ?[EH]?$)/ }"
                                    :error-messages="errors.collect('kennzeichen' + index)"
                                    :name="'kennzeichen' + index"
                                    data-vv-as="Kennzeichen"
                                    label="Kennzeichen"
                                    hint="Format XXX XX 0000, zum Beispiel: B XY 1234 E"
                                    class="show-errors required"
                                    persistent-hint
                                    @change="licensePlateChange(index, ...arguments)" />
                    </v-col>

                  </v-row>

                </v-col>

              </template>

              <v-col v-if="trafficType === 'Fahrzeug' && showkfz <4"
                      cols="12">
                <div class="btn-add"
                     @click="showkfz++">
                  <v-icon>add</v-icon>
                  <span>Fahrzeug hinzufügen</span>
                </div>
              </v-col>

            </v-row>
          </v-col>

        </v-row>

      </div>

    </template>

  </div>
</template>
<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import SelectTarif from "@/components/privatkundenrechner/SelectTarif";
import {RIGHTS} from "@/store/user";

export default {
  components: { SelectTarif },
  mixins: [twowayBinding, ValidationMixin],
  props: {
    aenderung: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    kfzs() {
      return [this.car1license, this.car2license, this.car3license, this.car4license, this.car5license];
    },
    showTraffic: function () {
      return this.categories.length === 1 &&
        this.categories.includes("V") &&
        this.activeTarif !== "securopremium";
    },
    threeYearsAllowed() {
      return !["securo", "securoplus", "securopremium"].includes(this.activeTarif);
    },
    fahrerRsAllowed() {
      return ["basis", "pool"].includes(this.activeTarif);
    },
    fahrzeugRsAllowed() {
      return ["basis", "pool", "mv", "mvmg"].includes(this.activeTarif);
    },
    familieVerkehrsRsAllowed() {
      return this.family === "MPH";
    },
    selectTarifAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    },
    ...mapTwoWay(
      [
        "anrede",
        "titel",
        "firstName",
        "lastName",
        "contractlength",
        "civilServant",
        "categories",
        "family",
        "trafficType",
        "car1license",
        "car2license",
        "car3license",
        "car4license",
        "car5license",
        "showkfz",
        "sus",
        "selectedTarif",
        "yoligazubi",
        "yoligrentner",
        "yoligekfz",
        "nurnachhaltig",
        "plzalter"
      ],
      {
        firstName: "vn.firstname",
        lastName: "vn.lastname",
        anrede: "vn.anrede",
        titel: "vn.titel"
      }
    ),
    activeTarif() {
      return this.$store.getters.activeTarif;
    },
    showMieterVorGericht() {
      return this.activeTarif === "mvmg";
    },
    showWohnen() {
      return this.activeTarif !== "mvmg" && this.activeTarif !== "mv";
    },
    showYoligOnly() {
      return this.$store.getters.showYoligOnly(this.statePath);
    },
    tarifCombinationsText() {
      let possibleCombinationsText;
      switch (this.activeTarif) {
        case "comfortplan":
          possibleCombinationsText = "Mögliche Kombinationen: PBVW, PBW, PVW, PBV";
          break;
        case "securo":
          possibleCombinationsText = "Mögliche Kombinationen: PBVW, PBV, V";
          break;
        case "securoplus":
          possibleCombinationsText = 'Ausschließlich "Privat" nicht möglich';
          break;
        case "securopremium":
          possibleCombinationsText = "Mögliche Kombinationen: PBVW, PBV, PVW";
          break;
        default:
          possibleCombinationsText = "";
          break;
      }
      return possibleCombinationsText;
    },
    maklerService() {
      return this.$store.state.staticPagesContent.AboutUnternehmenMaklerBox;
    }
  },
  watch: {
    selectedTarif(newValue, oldValue) {
      if (oldValue === "mvmg") {
        // option "M" is only available for mvmg, we remove it when tarif changes to something else
        this.categories = this.categories.filter(category => category !== "M");
      }
      if (newValue === "mvmg" || newValue === "mv") {
        // for Mieterverein, Wohnung cannot be selected. We remove it if it has been selected before
        this.categories = this.categories.filter(category => category !== "W");
      }
      if (!this.threeYearsAllowed) {
        this.contractlength = "1";
      }
    },
    familieVerkehrsRsAllowed(newValue) {
      if (newValue === false && this.trafficType === "Familie") {
        this.trafficType = "Versicherungsnehmer";
      }
    }
  },
  methods: {
    categoryChange: function () {
      // when categories change, product selection has to be cleared
      this.$store.commit("deselectProdukt", { rootState: this.$store.state, statePath: this.statePath });

      // deal with "Mietrechtsschutz vor Gericht"
      if (this.categories.includes("M")) {
        if (this.categories[this.categories.length - 1] === "M") {
          // just activated, clear everything else
          this.categories = ["M"];
        } else {
          // was active, but now something else was clicked -> remove
          this.categories = this.categories.filter(category => category !== "M");
        }
      }

      // remove Beruf and Wohnen when Privat is removed
      if (this.categories.indexOf("P") < 0) {
        this.categories = this.categories.filter(category => category !== "B" & category !== "W");
      }

      //cleanup YOLIG
      if (this.categories.indexOf("V") < 0) this.yoligekfz = false;
      if (this.categories.indexOf("B") < 0) this.yoligrentner = false;
      if (this.categories.indexOf("W") < 0 && this.categories.indexOf("B") < 0) this.yoligazubi = false;
    },
    licensePlateChange: function (index, val) {
      this[`car${index + 1}license`] = val.replace(/-/g, " ").toUpperCase();
      this.$nextTick(() => this.$validator.validate(`kennzeichen${index}`));
    },
    deleteKfz: function (index) {
      this.kfzs[index] = "";
      this[`car${index + 1}license`] = "";
      this.showkfz--;
    },
    checkSUS: function () {
      if (this.sus) {
        this.$store.commit("deselectProdukt", { rootState: this.$store.state, statePath: this.statePath });
      }
    }
  }
};
</script>
<style>
.basedata > .semanticsection-title2:first-child {
  margin-top: 0 !important;
}

.basedata > .section {
  margin-bottom: -16px !important;
  overflow: visible; /*30.04.20 changed from auto*/
}

.basedata .errormessage {
  font-size: 16px;
}

.basedata .trafficsection .v-input--selection-controls {
  margin-bottom: 26px !important;
  padding: 0;
}

.basedata .btn-add {
  border: none !important;
  margin: 16px 0 0 0 !important;
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.basedata .btn-add .v-icon, .basedata .btn-add span {
  color: rgba(0, 0, 0, .87);
  cursor: pointer;
}

.basedata .btn-add:hover .v-icon, .basedata .btn-add:hover span {
  color: #0085CF !important;
}

.basedata .kfz {
  padding: 16px 0 16px 0;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 402px;
}

@media (min-width: 960px) {
  .basedata #kfz-details {
    margin-top: -32px;
  }
}

@media (max-width: 959px) {
  .basedata #kfz-details {
    margin-top: 16px;
  }
}

.basedata .kfz .kfz-label {
  padding-left: 16px;
  color: #002C76;
  text-align: left;
  font-size: 16px;
}

.basedata .kfz .v-input {
  margin: 0;
  padding-right: 16px;
}

.basedata .kfz .delete-kfz {
  color: rgba(0, 0, 0, .87);
  cursor: pointer;
  z-index: 1;
  position: absolute;
  top: 8px;
  right: 8px;
}

.basedata .kfz + .kfz {
  margin-top: 16px;
}
.main {
  display:flex;
  justify-content:space-around;
}
</style>
